import { $api } from '@service/RequestService';
import { DATE_FORMAT } from '@utils/constants';
import { Pagination } from '@utils/models/Pagination';
import dayjs from 'dayjs';
import { useInfiniteQuery } from 'react-query';

import { summaryConstants, summaryModels } from '..';

export const useSummaryInsightLeaderboardInfinity = (
  props: { size: number; date: string; orders: Record<string, string>; enabled?: boolean } = {
    size: 10,
    date: dayjs().endOf('month').format(DATE_FORMAT),
    orders: {}
  }
) =>
  useInfiniteQuery<Pagination<summaryModels.Insight>>({
    queryKey: [summaryConstants.queryKeys.SUMMARY_INSIGHT_LEADERBOARD_INFINITY, props],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await $api.post('/v1/summary-insight/leaderboard', { ...props, page: pageParam });

      return res?.data?.data;
    },
    getNextPageParam: (lastPage, page) => {
      if (page.length < lastPage?.totalElements / props?.size) {
        return page.length + 1;
      }
      return undefined;
    },
    enabled: props?.enabled
  });
